var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkTableDialog',{ref:"currencySelectDialog",attrs:{"path":"system/currencies","headers":_vm.headers,"get-data":_vm.getData,"title":"Währung"}})
}
var staticRenderFns = []

export { render, staticRenderFns }